export const SERVICE_ACTION = "SERVICE_ACTION";
export const POST_WARRANTY_REPAIR = "POST_WARRANTY_REPAIR";
export const INSPECTION = "INSPECTION";
export const DURING_INSPECTION_P1 = "DURING_INSPECTION_P1";
export const DURING_INSPECTION_P2 = "DURING_INSPECTION_P2";
export const DURING_INSPECTION_P3 = "DURING_INSPECTION_P3";
export const COMPLAINT = "COMPLAINT";
export const SERVICE = "SERVICE";
export const CUSTOM_NUMBER = "CUSTOM_NUMBER";
export const ENTRY_IN_VEHICLE_BOOK = "ENTRY_IN_VEHICLE_BOOK";
export const TELEPHONE_ISSUE = "TELEPHONE_ISSUE";
export const CONSTRUCTION_CHANGE = "CONSTRUCTION_CHANGE";
